import { Alert, AlertColor, Autocomplete, Box, Button, CircularProgress, Collapse, IconButton, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, useTheme } from '@mui/material';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { useApi } from '../services/HttpService';
import { CenterSpinner } from '../components/ui/CenterSpinner';
import React from 'react';
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { InfoArea } from '../components/ui/InfoArea';
import EditIcon from '@mui/icons-material/Edit';
import { profile } from 'console';
import { SingleSelectChip } from '../components/ui/DropdownSelect';
import { ClickableIcon } from '../components/ui/Icon';

// Define TypeScript interfaces for the received data
interface OrderPrepaymentSolution {
  id: number;
  name: string;
  url: string;
  token1: string;
  token2: string;
  username: string;
  client_id: string;
  sys_payment_solution_id?: number | null;
}

interface Organization {
  id: number;
  name: string;
  url: string;
}

interface OrderPaymentprofile {
  id: number;
  name: string;
  post_ordering: boolean;
  order_prepayment_solution_id?: number | null;
  external_id?: string;
  available_options_for_change?: string;
}

interface Membership {
  id: number;
  name: string;
  order_paymentprofile_id?: number | null;
  organization_id: number;
}

export const ChangePayment = () => {
  const theme = useTheme();
  const { api: paymentApi, response: paymentApiResponse, isLoading: paymentApiIsLoading, error: paymentApiError } = useApi();
  const { api: updatePaymentApi, response: updatePaymentResponse, isLoading: updatePaymentIsLoading, error: updatePaymentError } = useApi();
  const [organizations, setOrganization] = useState<Organization[]>([]);
  const [paymentProfiles, setPaymentProfiles] = useState<OrderPaymentprofile[]>([]);
  const [memberships, setMemberships] = useState<Membership[]>([]);
  const [selectedMembership, setSelectedMembership] = useState<Membership>();
  const [selectedProfile, setSelectedProfile] = useState<OrderPaymentprofile>(null);
  const [openRows, setOpenRows] = useState<{ [key: number]: boolean }>({});
  const [editProfile, setEditProfile] = useState<number | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const editRef = useRef(null); // scroll to edit on edit click
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<AlertColor | undefined>('error');
  const [availableProfiles, setAvailableProfiles] = useState<OrderPaymentprofile[]>([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    paymentApi("/getPaymentData").then(res => {
      if (res && res.statusCode === 200) {
        setOrganization(res.data2 || []);
        setPaymentProfiles(res.data || []);
        setMemberships(res.data3 || []);
      }
    });
  };

  const organizationsMap = Object.fromEntries(
    organizations.map(org => [org.id, org.name])
  );

  const setDisplayMessage = (message: string, type: AlertColor = 'error') => {
    setMessage(message);
    setMessageType(type);
  }

  const toggleEditing = () => {
    setIsEditing(!isEditing);
  };

  const handleEditRegistration = (event, item) => {
    event.stopPropagation();
    setSelectedMembership(item);
    setSelectedProfile(item.order_paymentprofile_id || ""); // Use 'item' instead of 'selectedMembership'

    const currentProfile = paymentProfiles.find(profile => profile.id === item.order_paymentprofile_id);
    if (currentProfile?.available_options_for_change) {
      const allowedIds = currentProfile.available_options_for_change.split(",").map(Number);
      setAvailableProfiles(paymentProfiles.filter(profile => allowedIds.includes(profile.id)));
    } else {
      setAvailableProfiles([]);
    }

    toggleEditing();
  };

  const updatePayment = async () => {
    if (selectedProfile.order_prepayment_solution_id === selectedMembership.order_paymentprofile_id || selectedProfile.order_prepayment_solution_id === null){
      toggleEditing()
      return
    }
    selectedMembership.order_paymentprofile_id = selectedProfile.order_prepayment_solution_id
    await updatePaymentApi("/updateMembershipPaymentprofile", "POST", { ...selectedMembership}).then(res => {
      if (res && res.statusCode === 200) {
        if (res.redirect) {
          window.location.href = res.redirect; // Redirect user
        } else {
          // getData();
          toggleEditing();
          setDisplayMessage("Din betalingsmåte er endret ", "success")
        }
      } else {
        if (res.error) {
          if (res.error.code === "1") {
            setDisplayMessage("Det er skjedd en feil under oppdatering av data, venligst prøv igjen");
          } else if (res.error.code === "2") {
            setDisplayMessage("Feil, vi kunne ikke finne et medlemskap til deg");
          } else if (res.error.code === "3") {
            setDisplayMessage("Det er skjedd en feil under lagring av data, venligst prøv igjen");
          } else {
            setDisplayMessage("Det er skjedd en feil under oppdatering, prøv igjen");
          }
        }
      }
    });
  }

  return (
    <>
    <Box
      sx={{
        width: '30%', // Set a fixed width, you can adjust this
        minWidth: '600px', // Minimum width to prevent it from getting too small
        maxWidth: '1000px', // Optionally limit the maximum width
        margin: 'auto', // Center the content horizontally
      }}
    >
  

  <Typography variant='h4' sx={{ mt: 2, mb: 2, textAlign: 'center' }}>Endre betalingsmåte</Typography>

  <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: 1 }}>
    <CenterSpinner loading={paymentApiIsLoading} />
    {!paymentApiIsLoading && memberships.map((membership) => (
      <Box key={membership.id} sx={{ width: '100%' }}>
        <InfoArea >
          <TableContainer sx={{ width: '100%' }}>
            <Table>
              <TableHead>
                <TableRow>
                  {/* <TableCell>Medlemskap</TableCell> */}
                  <TableCell>Organisasjon</TableCell>
                  <TableCell>Betalingsmåte</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paymentProfiles.filter((profile) => profile.id === membership.order_paymentprofile_id)
                  .map((profile) => (
                    <TableRow key={profile.id} sx={{justifyContent:"space-between"}}>
                      {/* <TableCell>{membership.name}</TableCell> */}
                      <TableCell>{organizationsMap[membership.organization_id] || ""}</TableCell>
                      <TableCell>{profile.name}</TableCell>
                      <TableCell sx={{textAlign:"end"}}>

                      <ClickableIcon title="Rediger" disableInteractive={true} onClick={(event) => handleEditRegistration(event, membership)}>
                        <EditIcon color='inherit' />
                      </ClickableIcon>
                        {/* <IconButton title="Endre" onClick={(event) => handleEditRegistration(event, membership)}>
                          
                        </IconButton> */}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </InfoArea>
      </Box>
    ))}
  </Box>
  {isEditing && (
    <Box id="edit-box" ref={editRef} sx={{ width: '100%', mt: 5 }}>
      <InfoArea title={"Endre betalingsmåte for " + organizationsMap[selectedMembership.organization_id] || ""}>
        {selectedMembership.order_paymentprofile_id == 5 && <Alert sx={{ width: '100%' }} severity="warning">Du kan ikke bytte betalingsmåte under godkjenning av avtalegiro</Alert>}
        <SingleSelectChip
          label={'Betalingsmåte'}
          inputs={availableProfiles}
          selectField={'name'}
          required={true}
          selected={selectedProfile.order_prepayment_solution_id}
          onChange={(id: number) => setSelectedProfile({ ...selectedProfile, order_prepayment_solution_id: id })}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, p: 2 }}>
          <Button variant='contained' color='darkgrey' onClick={toggleEditing}>Avbryt</Button>
          <Button variant='contained' color='info' onClick={updatePayment} disabled={updatePaymentIsLoading} endIcon={updatePaymentIsLoading && <CircularProgress size={22} />}>
            Oppdater
          </Button>
        </Box>
      </InfoArea>
    </Box>
  )}
  <Box sx={{ mt: '15px', width: '50ch' }}>
    {message && <Alert severity={messageType}>{message}</Alert>}
  </Box>
</Box>
    </>
  );
};

export default ChangePayment;